<h2 i18n="@@restaurant-menu-header" class="widget-header h4 d-none d-lg-block">Restaurant menu</h2>
<div class="row justify-content-start" *ngIf="restaurants$ | async as restaurants">
    <div class="col-sm">
        <span class="bolder" i18n="@@restaurant-menu-list-title" id="restaurant_label">Restaurant:</span>
    </div>
    <div class="col-sm ml-1 restaurant-selector focus-border">
        <mat-select (selectionChange)="handleSelection($event)" role="listbox" placeholder="Select a restaurant" [(value)]="selectedRestaurant" i18n-aria-label="@@restaurant-menu-list-title" aria-label="Restaurant">
            <mat-option *ngFor="let restaurant of restaurants" role="option" aria-label="{{restaurant.Name}}" [value]="restaurant.Id">{{restaurant.Name}}</mat-option>
        </mat-select>
    </div>
</div>

<div *ngIf="restaurantMenus$ | async as restaurantMenus; else loading" class="compact-restaurant-menu-container mt-2">
  <ul class="row list-unstyled">
    <li *ngFor="let restaurantMenu of menuCardsToDisplay" class="li-width">
      <div class="site-container">
        <div class="site-initials">
          <div class="border-bottom week-number small">W {{restaurantMenu.WeekNumber}}</div>
          <div class="week-day small">{{restaurantMenu.WeekDay | slice:0:3}}</div>
        </div>
          <h3 class="site-title h6 mb-2" title="{{menu.value}}" *ngFor="let menu of restaurantMenu.menu">
                {{menu.value}}
          </h3>
       </div>
    </li>
  </ul>
  <div *ngIf="restaurantMenus && restaurantMenus.length === 0">
    <app-text-placeholder>
        <p i18n="@@restaurant-menu-no-restaurant-menus">There are no menus for the restaurant this week.</p>
    </app-text-placeholder>
</div>
</div>

<div  class="row justify-content-start" *ngIf="weeks && weeks.length > 5">
  <div class="col-auto pr-0 pl-0">
    <button mat-button class="events-show-more-btn" (click)="clickShowPrevious()" [disabled]="numberOfShowMoreClicks === 0">
      <span class="small bolder" i18n="@@show-previous">Previous</span>
    </button>
  </div>
  <div class="pt-2">
    <span class="dot mr-1" [ngClass]="numberOfShowMoreClicks === 0 ? 'accent-2-bg-color' : 'dot-bg-color'"></span>
    <span *ngIf="weeks && weeks.length > 5" class="dot mr-1" [ngClass]="numberOfShowMoreClicks === 1 ? 'accent-2-bg-color' : 'dot-bg-color'"></span>
    <span *ngIf="weeks && weeks.length > 10" class="dot" [ngClass]="numberOfShowMoreClicks === 2 ? 'accent-2-bg-color' : 'dot-bg-color'"></span>
  </div>
   <div class="col-auto pr-0 pl-0">
    <button mat-button class="events-show-more-btn" (click)="clickShowNext()" [disabled]="numberOfShowMoreClicks === 2 || numberOfShowMoreClicks === maxNumberOfShowMoreClicks">
      <span class="small bolder" i18n="@@show-next">Next</span>
    </button>
  </div>
 </div>

<ng-template #loading>
  <div *ngIf="errorSubject$ | async as err; else innerLoading">
    <app-error-templates [error]="err.status" [componentName]="componentName"></app-error-templates>
  </div>
  <ng-template #innerLoading>
    <div>
      <app-widget-placeholder></app-widget-placeholder>
    </div>
  </ng-template>
</ng-template>

